import { actionStatuses } from './Buttons/ActionButtons/Actions';

export default {
  actionButtons: {
    actionStatuses,
  },
};
